// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sportground-show .el-form-item__label{width:115px!important}.sportground-show .el-form-item__content{margin-left:115px!important}", ""]);
// Exports
module.exports = exports;
